export default __webpack_public_path__ + "static/media/pieLab.ddbe30cb.png";